import * as yup from 'yup';

const rootConst = 'FORGOT_PASSWORD_CHANGE_PASSWORD';

export const CHANGE_PASSWORD = `${rootConst}/CHANGE_PASSWORD`;
export const CHECK_TOKEN = `${rootConst}/CHECK_TOKEN`;

export const schema = yup.object({
  password: yup
    .string()
    .min(6, 'Atleast 6 characters')
    .required('Password is required.'),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords do not match'),
});
